/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  applyGlossariesToPage,
  previewLinks,
} from '../../store/Document/documentActions';

import './style.scoped.scss';
import { FaTag } from 'react-icons/fa';
import $ from 'jquery';
import {
  ClearTag,
  defineApplicableGlossaries,
  displayDocVersion,
} from '../../assets/constants/strings';
import Loader from '../Loader';
import Tag from '../Tag';
import ShareButton from '../ShareButton';

const MainContent = ({
  page,
  handlePageChange,
  isPreview,
  glossaries,
  handleDisplayGlossary,
  currentDocument,
  activeUser,
}) => {
  // const { pages } = currentDocument;
  const HTMLContent = page.HTMLContent;

  const [treatedHTML, setTreatedHTML] = useState(HTMLContent);
  const [loading, setLoading] = useState(false);

  const [previewHTML, setPreviewHTML] = useState(HTMLContent);

  const [applicableGlossaries, setApplicableGlossaries] = useState(null);

  useEffect(() => {
    if (!isPreview) {
      if (page && glossaries) {
        setLoading(true);

        // tab title
        if (
          currentDocument &&
          (!document.title.match('RegulationCity') ||
            !document.title.match(currentDocument.title))
        ) {
          document.title = displayDocVersion(currentDocument)
            ? displayDocVersion(currentDocument) + ' | RegulationCity'
            : 'RegulationCity';
        }

        // apply glossaries that relate to this page
        setTreatedHTML(applyGlossariesToPage(glossaries, HTMLContent));

        // get list of applicable glossaries to add click event listeners
        setApplicableGlossaries(defineApplicableGlossaries(glossaries));

        setLoading(false);
      } else setLoading(true);
    } else {
      if (glossaries)
        setPreviewHTML(applyGlossariesToPage(glossaries, HTMLContent));
    }
  }, [glossaries, page]);

  const handleTagSelected = (tag) => {
    handlePageChange('Search', tag);
  };

  useEffect(() => {
    addGlossaryListeners(isPreview ? previewHTML : treatedHTML);
    $('[data-toggle="tooltip"]').tooltip();
  });

  const addGlossaryListeners = (enhancedHTML) => {
    if (
      page !== null &&
      glossaries !== null &&
      applicableGlossaries !== null &&
      applicableGlossaries.length > 0
    ) {
      applicableGlossaries.forEach((glossary) => {
        if (
          glossary.Content.filter((item) => item.Definition.length >= 275)
            .length > 0
        ) {
          const { Content } = glossary;
          Content.filter((item) => item.Definition.length >= 275).forEach(
            (item) => {
              const key = item.Key;
              if (enhancedHTML.match(`MODAL_${key}`)) {
                document.getElementById(`MODAL_${key}`) &&
                  document
                    .getElementById(`MODAL_${key}`)
                    .addEventListener('click', () =>
                      handleDisplayGlossary(glossary.ID, key)
                    );
              }
            }
          );
        }
      });
    }
  };

  return (
    <React.Fragment>
      {page && !loading ? (
        <div className='main-content-wrapper'>
          <ShareButton
            currentDocument={currentDocument}
            user={activeUser}
            isSummary={false}
            currentPage={page}
          />
          <div
            id='content'
            dangerouslySetInnerHTML={{
              __html: isPreview ? previewLinks(page, previewHTML) : treatedHTML,
            }}
          ></div>
          <div className='tags d-flex pt-2'>
            <FaTag className='mr-2' fontSize='1.45rem' />
            <div className='d-flex flex-wrap'>
              {page.tags &&
                page.tags.split(',').map((tag) => {
                  if (tag.match('CUSTOMTAG')) {
                    // custom tag
                    return (
                      <div
                        onClick={() => handleTagSelected(ClearTag(tag))}
                        key={tag.trim()}
                        className='tag badge px-2 py-1 m-1 custom-tag'
                      >
                        <span>{ClearTag(tag)}</span>
                      </div>
                    );
                  } else if (
                    !(
                      tag.trim().length <= 2 || // has two characters
                      tag.match(/[^0-9a-z!\s]/gi) || // has non alphanumeric chars
                      (tag.match(/\d/g) && tag.match(/\d/g).length > 1)
                    ) // has more than one number
                  ) {
                    return (
                      <Tag
                        text={tag.trim()}
                        handleSelected={handleTagSelected}
                        key={tag.trim()}
                      />
                    );
                  } else return null;
                })}
            </div>
          </div>
        </div>
      ) : (
        <Loader text='Generating Contextual References...' />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  page: state.document.currentPage,
  isPreview: state.client.isPreview,
  allDocuments: state.client.documents,
  glossaries: state.client.glossaryList,
  currentDocument: state.document.currentDocument,
  activeUser: state.user.user,
});

const connector = connect(mapStateToProps);

export default connector(MainContent);
